import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/planning')({ component: PlanningLayout });

/** Layout della sezione Pianificazione: index (lista) e /new (form) nidificati. */
function PlanningLayout() {
  return <Outlet />;
}
